import ToggleIcon from "@assets/images/svg/toggleIcon.svg?react";
import ListIcon from "@mui/icons-material/List";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import { Editor } from "@tiptap/react";
import React, { useContext } from "react";

import { ToggleListHTML } from "../../Extension/ToggleButton";
import { useStyles as useSVBubbleStyles } from "../../PlusButtonMenu/styles";
import { SVEditorContext } from "../../SVEditorContext";
import { featureTitle } from "./constants";

// Menu item configuration array
const menuItemsConfig = [
  {
    title: featureTitle[0],
    blockAction: "<p></p>",
    icon: <TextFieldsIcon fontSize="small" />,
  },
  {
    title: featureTitle[1],
    blockAction: "<H1></H1>",
    icon: "H1",
  },
  {
    title: featureTitle[2],
    blockAction: "<H2></H2>",
    icon: "H2",
  },
  {
    title: featureTitle[3],
    blockAction: "<H3></H3>",
    icon: "H3",
  },
  {
    title: featureTitle[4],
    blockAction: "<ul><li><p></p></li></ul>",
    icon: <ListIcon fontSize="small" />,
  },
  {
    title: featureTitle[5],
    blockAction: ToggleListHTML,
    icon: <ToggleIcon width={20} height={20} />,
    isOptional: true, // Only render this if toggleButton is available
  },
];

export const TextGroupPlusMenu = ({
  editor,
  handleClose,
  setFeature,
  clickOneBlockAddAction,
}: {
  editor: Editor | null;
  handleClose?: () => void;
  setFeature: React.Dispatch<React.SetStateAction<string>>;
  clickOneBlockAddAction: (oneBlockValue?: string) => void;
}): JSX.Element => {
  const { optionalExtensions } = useContext(SVEditorContext);
  const classes = useSVBubbleStyles();

  return (
    <>
      {menuItemsConfig
        .filter((item) => !item.isOptional || optionalExtensions.toggleButton) // Filter for optional extensions
        .map((item) => (
          <MenuItem
            key={`plus-menu-button-menu-${item.title}`}
            onClick={() => {
              if (editor) {
                clickOneBlockAddAction(item.blockAction);
              }
              if (handleClose) {
                handleClose();
              }
              setFeature(item.title);
            }}
            classes={{ root: classes.MenuItem }}
          >
            <ListItemIcon className={classes.ListItemIconStyle}>
              {item.icon}
            </ListItemIcon>
            <ListItemText primary={item.title} />
          </MenuItem>
        ))}
    </>
  );
};
